import { render, staticRenderFns } from "./BuyOtherProgram.vue?vue&type=template&id=5224bff1&scoped=true"
import script from "./BuyOtherProgram.vue?vue&type=script&lang=js"
export * from "./BuyOtherProgram.vue?vue&type=script&lang=js"
import style0 from "./BuyOtherProgram.vue?vue&type=style&index=0&id=5224bff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224bff1",
  null
  
)

export default component.exports